export function InfoIcmsExclusao() {
  const reportData = {
    companyName: 'JOSE NORMANDO DO NASCIMENTO',
    cnpj: '24.545.634/0001-98',
    compensationDate: '15/04/2025',
    assessmentPeriod: '03/2025'
  }

  return (
    <div>
      <div className="max-w-2xl mx-auto">
        {/* Header */}

        {/* Main Content */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          {/* Content */}
          <div className="p-6 space-y-6">
            {/* Company Info */}

            {/* Compensation Details */}
            <div className="grid grid-cols-2 gap-3">
              <div className="text-center p-4 rounded-lg">
                <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Data de Compensação</p>
                <p className="text-lg font-semibold text-gray-900">{reportData.compensationDate}</p>
              </div>
              {/* <div className="text-center">
                <h2 className="text-lg font-semibold text-gray-900 mb-1">{reportData.companyName}</h2>
                <p className="text-gray-600 font-mono text-sm">CNPJ: {reportData.cnpj}</p>
              </div> */}
              <div className="text-center p-4 rounded-lg">
                <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">Período de Apuração</p>
                <p className="text-lg font-semibold text-gray-900">{reportData.assessmentPeriod}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InfoIcmsExclusao
